// adminfrontend/src/admin_ui/services/adminAnalyticsApi.js
import adminApiClient from "./adminApiClient";

const adminAnalyticsApi = {
  async runForecastJob(payload) {
    try {
      const res = await adminApiClient.post("/api/analytics/forecast-jobs", payload);
      return res.data;
    } catch (e) {
      return { ok: false, error: e?.response?.data?.error || e.message || "Request failed" };
    }
  },

  async listForecastJobs(params) {
    try {
      const res = await adminApiClient.get("/api/analytics/forecast-jobs", { params });
      return res.data;
    } catch (e) {
      return { ok: false, error: e?.response?.data?.error || e.message || "Request failed" };
    }
  },

  async listForecastResults(params) {
    try {
      const res = await adminApiClient.get("/api/analytics/forecast-results", { params });
      return res.data;
    } catch (e) {
      return { ok: false, error: e?.response?.data?.error || e.message || "Request failed" };
    }
  },
};

export default adminAnalyticsApi;
